<template>
    <base-dialog :loading="loading" :value="dialog" :width="460" :title="$t('habits.student_goals')"
        @input="val => { if (!val) hide() }" @close="hide">
        <div v-if="assignment" class="sg-body">
            <div class="sg-hint">{{ $t('habits.student_goals_hint') }}</div>
            <div v-for="habit in numericHabits" :key="habit.key" class="sg-row">
                <habit-icon :category="habit.category" :size="30" />
                <div class="sg-name text-truncate">{{ habitName(habit) }}</div>
                <input class="sg-input" v-model="goals[habit.key]" inputmode="decimal" :placeholder="formatHabitNumber(habit.goal)" />
                <span class="sg-unit">{{ habitUnitLabel(habit.unit) }}</span>
            </div>
            <div v-if="!numericHabits.length" class="sg-hint">{{ $t('habits.student_goals_empty') }}</div>
        </div>
        <template v-slot:footer>
            <dialog-actions :confirm-label="$t('common.save')" :loading="loading" @cancel="hide" @confirm="save" />
        </template>
    </base-dialog>
</template>

<script>
import { db } from '@/utils/Firebase'
import BaseDialog from '@/components/common/BaseDialog'
import DialogActions from '@/components/common/DialogActions'
import HabitIcon from './HabitIcon.vue'
import habitsMixin from '@/mixins/habitsMixin'

export default {
    name: 'StudentHabitGoalsDialog',
    mixins: [habitsMixin],
    components: { BaseDialog, DialogActions, HabitIcon },
    data() {
        return {
            dialog: false,
            loading: false,
            assignment: null,
            goals: {},
        }
    },
    computed: {
        numericHabits(vm = this) {
            return (vm.assignment?.combo?.habits || []).filter(habit => habit.type !== 'bool')
        },
    },
    methods: {
        show(assignment) {
            const vm = this
            vm.assignment = assignment
            vm.goals = { ...(assignment.goals || {}) }
            vm.dialog = true
        },
        hide() {
            this.dialog = false
        },
        async save() {
            const vm = this
            const goals = {}
            Object.keys(vm.goals).forEach(key => {
                const value = Number(String(vm.goals[key] ?? '').replace(',', '.'))
                if (Number.isFinite(value) && value > 0) goals[key] = value
            })
            await vm.withLoading(async () => {
                await db.collection('habitAssignments').doc(vm.assignment.id).update({ goals })
                vm.toast(vm.$t('common.changes_saved'))
                vm.$emit('success', goals)
                vm.hide()
            })
        },
    },
}
</script>

<style scoped>
.sg-body {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.sg-hint {
    font-size: 12px;
    color: var(--v-txtMuted-base);
}

.sg-row {
    display: flex;
    align-items: center;
    gap: 10px;
}

.sg-name {
    flex: 1;
    font-size: 13px;
    color: var(--v-txtPrimary-base);
}

.sg-input {
    width: 80px;
    height: 34px;
    padding: 0 10px;
    border-radius: 8px;
    border: 1px solid var(--v-outline-base);
    background: var(--v-surface2-base);
    color: var(--v-txtPrimary-base);
    text-align: right;
    outline: none;
}

.sg-input:focus {
    border-color: var(--v-accent-base);
}

.sg-unit {
    width: 56px;
    font-size: 11px;
    font-weight: 700;
    color: var(--v-txtMuted-base);
}
</style>
